import React from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardText,
  Button,
} from 'reactstrap';
import RkCarousel from '../common/RkCarousel';
import { Link } from 'react-router-dom';
import repairsLandingImage from '../../images/repairs-landing.jpg';
import operationLandingImage from '../../images/operation-landing.jpg';
import jettingLandingImage from '../../images/sewer-jetting-landing.jpg';

const HomePage = () => {
  return (
    <div>
      <Container fluid={true}>
        <RkCarousel />

        <Row>
          <Col md={12} className="mt-4 text-center">
            <h1>Welcome to RK Water Operations</h1>
          </Col>
        </Row>

        <Row>
          <Col md={2}></Col>
          <Col md={8} className="mt-4 text-center">
            <h2>
              Quality water and wastewater system operation, repairs, and sewer
              jetting services in Missouri and Arkansas
            </h2>
          </Col>
        </Row>

        <Row>
          <Col md={1}></Col>
          <Col md={10} className="mt-4 main">
            <p>
              We take pride in offering quality water management and repair
              services. Our {new Date().getFullYear() - 1994} years of
              management experience has given us a profound understanding of
              water and wastewater systems. Our friendly and courteous staff are
              dedicated to giving you the best possible service. We strive to
              make a difference in the lives of our customers through better
              water management.
            </p>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <hr className="featurette-divider" />
          </Col>
        </Row>

        <Row>
          <Col md={12} className="my-4 text-center">
            <h3>Our Services</h3>
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <Card>
              <CardImg
                top
                width="100%"
                src={operationLandingImage}
                alt="System Operation Services"
              />
              <CardBody>
                <CardTitle>System Operation</CardTitle>
                <CardText>
                  We can operate your water or wastewater systems. Our operators
                  are fully licensed in Arkansas and Missouri.
                </CardText>
              </CardBody>
            </Card>
          </Col>

          <Col md={4}>
            <Card>
              <CardImg
                top
                width="100%"
                src={repairsLandingImage}
                alt="Repair Services"
              />
              <CardBody>
                <CardTitle>Repair Services</CardTitle>
                <CardText>
                  Repair services for water and wastewater systems including
                  leaks, valves, fire hydrants, treatment plant repairs, etc.
                </CardText>
              </CardBody>
            </Card>
          </Col>

          <Col md={4}>
            <Card>
              <CardImg
                top
                width="100%"
                src={jettingLandingImage}
                alt="Sewer Jetting Services"
              />
              <CardBody>
                <CardTitle>Sewer Jetting</CardTitle>
                <CardText>
                  Sewer jetting is a method of cleaning gravity mains using high
                  pressure water.
                </CardText>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="text-center my-4">
            <Button tag={Link} to="/services">
              See All Services
            </Button>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <hr className="featurette-divider" />
          </Col>
        </Row>

        <Row>
          <Col md={12} className="my-4">
            <p className="text-center action-call">Call Now!</p>
            <p className="text-center action-call">(870) 437-5353</p>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/home/HomePage.js